require('jquery-ui/ui/keycode');

require('jquery-ui/ui/widgets/datepicker');

require('jquery-ui/themes/base/core.css');

require('jquery-ui/themes/base/datepicker.css');